import React, { useEffect, useRef, useState } from "react";
import "./Preloader.css";
import "animate.css";

const Preloader = ({ isLoading, text }) => {
  const b2bContainerRef = useRef(null);
  const rollOverlayRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if screen is mobile size
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust breakpoint as needed
    };

    // Initial check
    checkMobile();

    // Add resize listener
    window.addEventListener("resize", checkMobile);

    // Cleanup
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    if (isLoading && !isMobile) {
      // Animation timing constants
      const INITIAL_DELAY = 0; // Time before starting the animation
      const ANIMATION_DURATION = 100; // Duration of the animation
      const ROLL_DELAY = 900; // Delay before roll animation after animation completes

      // Reveal the B2B
      setTimeout(() => {
        if (b2bContainerRef.current) {
          b2bContainerRef.current.classList.add("show-b2b");
        }
      }, INITIAL_DELAY);

      // Roll white overlay from bottom after animations complete
      setTimeout(
        () => {
          if (rollOverlayRef.current) {
            rollOverlayRef.current.classList.add("roll-up");
          }
        },
        INITIAL_DELAY + ANIMATION_DURATION + ROLL_DELAY
      );
    }
  }, [isLoading, isMobile]);

  // Don't render on mobile
  if (isMobile) return null;

  return (
    <div
      className={`preloader-wrapper ${!isLoading ? "preloader-fade-out" : ""}`}
    >
      <div className='text-container'>
        <span className='marketingova'>{text?.marketingova || 'Marketing'}</span>

        <div ref={b2bContainerRef} className='b2b-container'>
          <span className='b2b'>{text?.b2b || 'B2B'}</span>
        </div>

        <span className='agentura'>{text?.agentura || 'agency'}</span>
      </div>
      <div ref={rollOverlayRef} className='roll-overlay'></div>
    </div>
  );
};

export default Preloader;
